<h1 mat-dialog-title>{{ data.dialogTitle }}</h1>
<div mat-dialog-content>
  <a href="#" (click)="addCouponLevel()">Create New</a>
  <table>
    <tbody>
      <tr>
        <th><span>Coupon Code</span></th>
        <th><span>Subscription Type</span></th>
        <th><span>Subscription Level</span></th>
        <th><span>Subscription URL</span></th>
        <th><span></span></th>
      </tr>

      <ng-container *ngFor="let ddItem of couponLevels">
        <tr>
          <td>
            <span>{{ ddItem.CouponCode }}</span>
          </td>
          <td>
            <span>{{ ddItem.SubscriptionType }}</span>
          </td>
          <td>
            <span>{{ ddItem.SubscriptionLevel }}</span>
          </td>
          <td>
            <span>{{ ddItem.PurchaseUrl }}</span>
          </td>
          <td>
            <span>
              <a href="#" (click)="deleteCouponLevel(ddItem)">Delete</a
              >&nbsp;&nbsp;|&nbsp;&nbsp;
            </span>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="onConfirmClick()">
    Save Coupon Levels
  </button>
  <button mat-raised-button (click)="onCancelClick()">Cancel</button>
</div>
